import { render, staticRenderFns } from "./ParcelshopDetails.vue?vue&type=template&id=4424d9cf&scoped=true"
import script from "./ParcelshopDetails.vue?vue&type=script&lang=js"
export * from "./ParcelshopDetails.vue?vue&type=script&lang=js"
import style0 from "./ParcelshopDetails.vue?vue&type=style&index=0&id=4424d9cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../tracking/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4424d9cf",
  null
  
)

export default component.exports